import React from "react";
import { NavLink } from "react-router-dom";

export const AsideMenu = ({ children }) => {
    return (
        <div
            style={{ width: "240px" }}
            className="h-100 bg-white border-right overflow-auto"
        >
            {children}
        </div>
    )
}

const AsideMenuNavItem = ({ to, children, exact = false }) => {
    return (
        <NavLink
            exact={exact}
            to={to || "#"}
            style={{
                padding: "12px 16px",
                display: "block",
            }}
            className={isActive => isActive ? "text-primary text-hover-primary bg-light-primary" : "text-dark text-hover-primary"}
        >
            {children}
        </NavLink>
    )
}

AsideMenu.NavItem = AsideMenuNavItem

